"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENTS_ONLY_GBP_TIER_LIMIT_PENCE = void 0;
/** PAYMENTS_ONLY catalogue over-limit: £1M volume, GBP buckets only. */
exports.PAYMENTS_ONLY_GBP_TIER_LIMIT_PENCE = 100000000;
